<template>
<div>
     <div class="indback-bar" @click="goback">
        <i class="iconfont icon-leftdefalut"></i>
        <span>返回</span>
    </div>
    <div class="jobfair-box">
        <div class="jobf-tobar">
            <div class="jobf-tit jobf-tit-before">企业认证<span class="jobf-tit-fu">（请填写真实企业信息）</span></div>
        </div>
        <ul class="jobfair-compy">
            <li class="clearfix">
                <div class="j-c-tit">管理者姓名</div>
                <input class="j-c-inp" type="text" placeholder="请输入姓名" v-model="adminName">
            </li>
            <li class="clearfix j-c-secondli">
                <div class="j-c-tit">管理者联系电话</div>
                <input class="j-c-inp" type="number" placeholder="请输入联系电话" v-model="adminPhone">
            </li>
            <li class="clearfix">
                <div class="j-c-tit">执照号码</div>
                <input class="j-c-inp" v-model="license" type="text" placeholder="请输入营业执照号码或统一社会信用代码">
            </li>
            <li class="clearfix">
                <div class="j-c-tit">营业执照</div>
                <div class="yefilebox" v-loading="loading2" element-loading-text="上传中，请稍等"
>
                    <input @change="licenseChange" type="file" />
                    <img v-if="licenseImg" class="yefile-chuan" :src="licenseImg">
                    <img class="yefile-chuan" v-else src="../../assets/images/picchuan.png">

                </div>
            </li>
        </ul>
        <div class="gorz" @click="gorz">确认认证</div>
    </div>

</div>
</template>
<script>
import { mapState, mapGetters, mapMutations } from "vuex";
const qs = require("qs");
export default {
  data() {
    return {
      adminName: "",
      adminPhone: "",
      license: "",
      licenseImg: "",
      loading2: false
    };
  },
  methods: {
    goback() {
      this.$router.back();
    },
    licenseChange(event) {
      let url = `/wapi/base/upload/licenseImg`;
      let formdata = new FormData();
      formdata.append("licenseImgFile", event.target.files[0]);
      this.loading2 = true;
      this.axios.post(url, formdata).then(res => {
        setTimeout(() => {
          this.loading2 = false;
        }, 500);
        if (res.status == 200) {
          this.licenseImg = res.data;
        }
        if (res.status == 400) {
          this.$message({
            type: "warning",
            message: "上传出现错误，请稍后再试"
          });
          return;
        }
      });
    },
    gorz() {
      let url = `/wapi/company/applyAuth`;
      let qdata = {
        legalName: this.adminName,
        legalPhone: this.adminPhone,
        license: this.license,
        licenseImg: this.licenseImg
      };
      this.axios.post(url, qs.stringify(qdata)).then(res => {
        if (res) {
          if (res.success) {
            if (res.msg == "企业已认证") {
              this.$message({
                type: "warning",
                message: "已认证"
              });
              return;
            }
            this.$message({
              type: "success",
              message: "提交成功，请等待审核"
            });
            setTimeout(() => {
              this.$router.back();
            }, 1500);
          }
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
@import "../../assets/css/main";
.gorz {
  .btn-blue(200px,45px,14px);
  margin: 40px 0 0 100px;
}
.jobfair-box {
  padding-bottom: 80px;
}
.yefilebox {
  width: 378px;
  height: 152px;
  overflow: hidden;
  position: relative;
  input {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    font-size: 150px;
    opacity: 0;
    z-index: 100;
    cursor: pointer;
  }
  img {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
  div {
  }
}
</style>



// WEBPACK FOOTER //
// compyrz.vue?7f273de8